// "Photographers see only their own photos" (revenue splitting Step 4): the admin mint skips a file whose name is
// already taken by a photo credited to someone else (reason NOT_YOUR_PHOTO) — it is never overwritten. The uploader
// says so per file and once per batch.
export const NOT_YOUR_PHOTO = "NOT_YOUR_PHOTO";

/** The per-file message (the server sends the same text as `message`). */
export const NOT_YOURS_MESSAGE = "A photo with this name, credited to someone else, is already here. It wasn't replaced.";
